module.exports = __webpack_public_path__ + "static/img/cyber-bullying.5b5de3df.jpg";